import { render } from "./FormattedNumber.vue?vue&type=template&id=01773be4"
import script from "./FormattedNumber.vue?vue&type=script&lang=js"
export * from "./FormattedNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__